import { render } from "./ViewFederation.vue?vue&type=template&id=74d8e6de&scoped=true"
import script from "./ViewFederation.vue?vue&type=script&lang=js"
export * from "./ViewFederation.vue?vue&type=script&lang=js"

import "./ViewFederation.vue?vue&type=style&index=0&id=74d8e6de&scoped=true&lang=css"
import "./ViewFederation.vue?vue&type=style&index=1&id=74d8e6de&scoped=true&lang=css"
import "./ViewFederation.vue?vue&type=style&index=2&id=74d8e6de&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d8e6de"]])

export default __exports__